import React, { useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import NavBar from '../NavBar';
import { Footer } from './Footer';
import { blog, blogTitle } from '../../constants/Footer/blog';

import './Blog.css';

export const BlogPost = () => {
  const navigate = useNavigate();
  const { blogId } = useParams();

  const blogPage = blog.find((blogPost) => blogPost.id === blogId);
  useEffect(() => {
    if (!blogPage) {
      const timer = setTimeout(() => navigate('/blogs'), 3000);
      return () => clearTimeout(timer);
    }
  }, [blogPage]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!blogPage) {
    return <h2 className="blogNotFound">Blog not found. Redirecting... </h2>;
  }

  const handleMixpanelDashboardTrack = () => {
    mixpanel.track('Blogs_Page_To_Dashboard', {
      from_path: `/blogs/${blogPage.id}`,
      title: blogPage.title,
    });
  };

  return (
    <>
      <NavBar currentPath="blogs" />
      <div className="blogPostContainer">
        <div className="blogPostHeader">
          <h3 className="blogPostH3">{blogPage.title}</h3>
          {/* <p className="blogIntro"> {blogPage.intro}</p> */}
          <h6 className="blogPostdate">{blogPage.date}</h6>
          <div
            className="imgText"
            style={{
              backgroundImage: `url(${blogPage.imageUrl})`,
            }}
          >
            <img src={blogPage.imageUrl} alt="" className="img" />
          </div>
        </div>

        <div className="blogSection">
          <Container className="blogContainerSection" maxWidth="lg">
            <Box mb={4}>
              {blogPage.contentSteps.map((step, stepIndex) => (
                <Box key={step.step_number} mb={4} sx={{ mb: 1 }}>
                  <h5 className="h5Title">
                    {stepIndex + 1}. {step.title}
                  </h5>
                  <p className="stepSubtitle"> {step.subtitle}</p>

                  {step.content.map((item) => (
                    <div key={uuidv4()} className="stepContent">
                      <div className="blogPost">
                        <div className="titleSection">
                          <h6 className="tableTitle">{item.title}</h6>
                        </div>

                        {Array.isArray(item.description) ? (
                          <table className="table-container">
                            <thead className="table-header">
                              <tr>
                                <th className="table-cell feauture">{blogTitle.feature} </th>
                                <th className="table-cell feauture">{blogTitle.autoLoan} </th>
                                <th className="table-cell feauture">{blogTitle.lease}</th>
                              </tr>
                            </thead>
                            <tbody className="table-body">
                              {item.description.map((row) => (
                                <tr key={row.feature + row.autoLoan}>
                                  <td className="table-cell feauture">{row.feature}</td>
                                  <td className="table-cell">{row.autoLoan}</td>
                                  <td className="table-cell">{row.lease}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <div className="blogDescription">{item.description}</div>
                        )}
                      </div>
                    </div>
                  ))}
                </Box>
              ))}
            </Box>
            <div className="callToAction">
              <a href="/dashboard" className="cta" onClick={handleMixpanelDashboardTrack}>
                {blogPage.callToAction}
              </a>
            </div>
          </Container>
        </div>
      </div>

      <Footer currentPath={'/blogs'} />
    </>
  );
};
